import { SelectBox, Switch } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, FormGroup, Input, Label } from 'reactstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { useAuth } from '../../auth';
import Breadcrumb from '../../components/common/breadcrumb';
import api from '../../services/api-configuration';
import { getAllWarehouses } from '../../services/apis';
import useFormatMessage from '../../utils/useFormatMessage';
import AlgoritmaSecimi from './AlgoritmaSecimi';

const EnhancedAddressAssignment = () => {
    const { hasRole } = useAuth(7);
    const { t } = useFormatMessage();
    const [zones, setZones] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [selectedZone, setSelectedZone] = useState(null);
    const [selectedWareHouse, setSelectedWareHouse] = useState(
        localStorage.getItem("warehouse") ? parseInt(Buffer.from(localStorage.getItem("warehouse"), 'base64').toString('ascii')) : null
    );
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [chassisNumber, setChassisNumber] = useState('');
    const [warehouse, setWarehouse] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const notifySuccess = (message) => toast.success(message);
    const notifyError = (message) => toast.error(message);

    const [algorithmSelected, setAlgorithmSelected] = useState({
        algorithm_type: 'X_COUNT',
        direction: 'START',
        scan_type: 'HORIZONTAL',
        x_count: 1
    });

    const validateFields = (chassiss) => {
        if (!selectedWareHouse) {
            notifyError(t('Please select a warehouse'));
            return false;
        }
        if (!selectedZone) {
            notifyError(t('Please select a zone'));
            return false;
        }
        if (chassiss === true) {
            if (!selectedAddress) {
                notifyError(t('Please select an address'));
                return false;
            }
        }
        if (chassiss === true) {
            if (!chassisNumber || chassisNumber.length !== 17) {
                notifyError(t('Chassis number must be 17 characters'));
                return false;
            }
        }
        return true;
    };

    useEffect(() => {
        if (selectedWareHouse) {
            fetchZones(Number(selectedWareHouse));
        }
        // eslint-disable-next-line
    }, [selectedWareHouse]);

    useEffect(() => {
        if (selectedZone) {
            fetchAddresses('', false);
        }
        // eslint-disable-next-line
    }, [algorithmSelected]);

    useEffect(() => {
        fetchWarehouse();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (selectedZone) {
            fetchAddresses();
        }
        // eslint-disable-next-line
    }, [selectedZone]);

    const fetchZones = async (e) => {
        try {
            const response = await api.post('/zone/getZonesByWarehouse', {
                warehouse_id: e
            });
            let all_Data = response.data.data || []
            all_Data = all_Data.filter((item) => item.is_active === true
                && item.zone_type !== "TYPE_RECEPTION"
                && item.zone_name !== "SANAL"

            );
            setZones(all_Data);
        } catch (error) {
            console.error('Error fetching zones:', error);
            notifyError(t('Error fetching zones'));
        }
    };

    const fetchWarehouse = async () => {
        try {
            const res = await getAllWarehouses();
            setWarehouse(res)
        } catch (error) {
            console.error('Error fetching warehouse:', error);
            notifyError(t('Error fetching warehouse'));
        }
    }

    const fetchAddresses = async (address, current) => {
        let currentAddress = current === true ? selectedAddress : '';
        let body = {
            algorithm_type: algorithmSelected.algorithm_type,
            direction: algorithmSelected.direction,
            scan_type: algorithmSelected.scan_type,
            x_count: algorithmSelected.x_count,
            zone_id: selectedZone
        };

        if (current === true) {
            body.skip_address = '';
            body.last_selected_address = currentAddress;
        } else if (current === false) {
            body.skip_address = address;
            body.last_selected_address = '';
        }

        try {
            const response = await api.post('/getAddressSuggestion', body);
            setAddresses(response.data.data.addresses);
            setSelectedAddress(response.data.data.suggested_address);
        } catch (error) {
            let message = ": " + error?.response?.data?.error || ""
            console.error('Error fetching addresses:', message);
            notifyError(t('Error fetching addresses') + message);
        }
    };

    const handleZoneChange = (e) => {
        setSelectedZone(e.value);
        setSelectedAddress(null);
    };

    const handleChassisNumberInput = (e) => {
        const value = e.target.value;
        if (value.length <= 17) {
            setChassisNumber(value);
        }
    };

    const onAssignAddress = async () => {
        if (hasRole("yerinde_adresleme_write") === false) {
            toast.error("Bu işlemi yapmaya yetkiniz yoktur.");
            return
        }
        if (!validateFields(true)) {
            return;
        }

        try {
            const response = await api.post('/assignChassis', {
                address_code: selectedAddress,
                chassis_no: chassisNumber,
                zone_id: selectedZone
            });
            notifySuccess(response.data.message);
            setChassisNumber(''); // Clear chassis number after successful assignment
            setTimeout(() => {
                fetchAddresses(document.getElementById("address-select").childNodes[0].childNodes[0].value, true);
            }, 1000);
        } catch (error) {
            if (error.response?.data?.error) {
                Swal.fire({
                    icon: 'error',
                    title: 'HATA',
                    text: error.response.data.error,
                    confirmButtonText: 'OK',
                    animation: true,
                    showCancelButton: false,
                    showCloseButton: false,
                    confirmButtonColor: 'rgb(255 84 84)',
                    allowOutsideClick: false,
                });
            }
            else if (error.response?.data?.status === "error") {
                // let message = error.response.data.message.includes("askıya alınmış") ? "Error updating address" : error.response.data.message;
                Swal.fire({
                    icon: 'error',
                    title: 'HATA',
                    text: error.response.data.message,
                    confirmButtonText: 'OK',
                    animation: true,
                    showCancelButton: false,
                    showCloseButton: false,
                    confirmButtonColor: 'rgb(255 84 84)',
                    allowOutsideClick: false,
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error updating address',
                    confirmButtonText: 'OK',
                    animation: true,
                    showCancelButton: false,
                    showCloseButton: false,
                    confirmButtonColor: 'rgb(255 84 84)',
                    allowOutsideClick: false,
                });
            }
            console.error('Error updating address:', error);
        }
    };

    const handleSkipAddress = async () => {
        if (!validateFields(false)) {
            return;
        }
        await fetchAddresses(
            document.getElementById("address-select").childNodes[0].childNodes[0].value,
            false
        );
    };

    // Add event listener for barcode scanner
    useEffect(() => {
        let barcodeBuffer = '';
        let lastKeyTime = Date.now();

        const handleBarcodeScanner = (event) => {
            const currentTime = Date.now();

            // If the delay between keystrokes is longer than 50ms, assume it's manual input
            if (currentTime - lastKeyTime > 50) {
                barcodeBuffer = '';
            }

            lastKeyTime = currentTime;

            // Only process printable characters
            if (event.key.length === 1) {
                barcodeBuffer += event.key;
            }

            // Process when Enter key is pressed or buffer reaches 17 chars
            if (event.key === 'Enter' || barcodeBuffer.length === 17) {
                if (barcodeBuffer.length === 17) {
                    setChassisNumber(barcodeBuffer);
                    if (!validateFields(true)) {
                        barcodeBuffer = '';
                        return;
                    }
                    onAssignAddress();
                }
                barcodeBuffer = '';
            }
        };

        window.addEventListener('keydown', handleBarcodeScanner);
        return () => {
            window.removeEventListener('keydown', handleBarcodeScanner);
        };
        // eslint-disable-next-line
    }, [selectedWareHouse, selectedZone, selectedAddress]); // Add dependencies

    return (
        <>
            <Breadcrumb current={t("Yerinde Adresleme")} />
            <Card className="p-3">
                <CardBody>
                    <FormGroup row className="justify-content-between align-items-center">
                        <Col
                            md={6} sm={12} xs={12}
                            className="d-flex align-items-center justify-content-between"
                        >
                            <span>
                                <b>{algorithmSelected.direction === "START" ? "Baştan" : "Sondan"}</b> Başla &nbsp;
                                <b>{algorithmSelected.scan_type === "VERTICAL" ? "Dikey" : "Yatay"}</b> İlerle &nbsp;
                                {algorithmSelected.algorithm_type === "X_COUNT" ? <><b>{algorithmSelected.x_count}</b> Adet.</> : <>Tümü</>}
                            </span>
                            <i className="fa fa-cog text-primary" onClick={() => setIsOpen(true)} style={{ cursor: "pointer", fontSize: "20px", fontWeight: "bold" }}></i>
                        </Col>
                    </FormGroup>

                    <hr />

                    <FormGroup row>
                        <Label for="print-switch" className="control-label col-md-3 col-xs-4 d-flex align-items-center justify-content-between">
                            <span>
                                {t("Etiket Yazdır")}
                            </span>
                        </Label>
                        <div className="col-md-3 col-xs-8">
                            <div className="form-check form-switch p-0">
                                <Switch
                                    id="print-switch"
                                    width={"50%"}
                                    switchedOffText="No"
                                    switchedOnText="Yes"
                                />
                            </div>
                        </div>
                    </FormGroup>

                    <FormGroup row>
                        <Label for="warehouse-select" className="control-label col-md-3 col-xs-4">
                            {t("Depo")}
                        </Label>
                        <div className="col-md-3 col-xs-8">
                            <SelectBox
                                id="warehouse-select"
                                items={warehouse}
                                value={selectedWareHouse}
                                valueExpr={'id'}
                                displayExpr={'warehouse_name'}
                                onValueChanged={(e) => {
                                    setSelectedWareHouse(e.value)
                                    // fetchZones(Number(e.value))
                                    setSelectedAddress(null)
                                }}
                            />
                        </div>
                    </FormGroup>

                    <FormGroup row>
                        <Label for="zone-select" className="control-label col-md-3 col-xs-4">
                            {t("Bölge")}
                        </Label>
                        <div className="col-md-3 col-xs-8">
                            <SelectBox
                                id="zone-select"
                                items={zones}
                                value={selectedZone}
                                valueExpr={'id'}
                                displayExpr={'zone_name'}
                                onValueChanged={handleZoneChange}
                            />
                        </div>
                    </FormGroup>

                    <FormGroup row className="d-flex">
                        <Label for="address-select" className="control-label col-md-3 col-xs-4" style={{ width: "max-content" }}>
                            {t("Adres")}
                        </Label>
                        <div className="col-md-3 col-xs-8">
                            <SelectBox
                                id="address-select"
                                items={addresses}
                                value={selectedAddress}
                                searchEnabled={true}
                                valueExpr={"address_code"}
                                displayExpr={(data) => {
                                    if (data) {
                                        return `${data.address_code} (${Number(data.used_capacity)} / ${Number(data.capacity)})`;
                                    }
                                }}
                                onValueChanged={(e) => setSelectedAddress(e.value)}
                            />
                        </div>
                    </FormGroup>

                    <FormGroup row>
                        <Label for="chassis-number" className="control-label col-md-3 col-xs-4">
                            {t("Şase")}
                        </Label>
                        <div className="col-md-3 col-xs-8">
                            <Input
                                type="text"
                                id="chassis-number"
                                className="form-control input-sm"
                                placeholder="Enter or Scan Chassis Number"
                                value={chassisNumber}
                                onChange={handleChassisNumberInput}
                                maxLength={17}
                                required
                                autoComplete="off"
                            />
                        </div>
                    </FormGroup>

                    <hr />
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <Button
                                color="danger"
                                block
                                onClick={handleSkipAddress}>
                                <i className="fa fa-rotate-right"></i>&nbsp;
                                {t("Adresi Geç")}
                            </Button>
                        </div>
                        <div className="col-md-6">
                            <Button
                                color="success"
                                block
                                disabled={!hasRole("yerinde_adresleme_write")}
                                onClick={onAssignAddress}>
                                <i className="fa fa-check text-white"></i>&nbsp;
                                {t("Adresle")}
                                {/* Assign */}
                            </Button>
                        </div>
                    </div>
                </CardBody>
            </Card>

            <AlgoritmaSecimi
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                setAlgorithmSelected={setAlgorithmSelected}
                algorithmSelected={algorithmSelected}
            />
        </>
    );
};

export default EnhancedAddressAssignment;